/**
 * Top banner shown only on the preview (non-production) environment.
 * Hidden automatically when the app is running on a known production
 * domain so live users never see it.
 */
export default function PreviewEnvBanner() {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const PROD_HOSTS = ["depot.portside.nl", "portside-ops.emergent.host"];
  if (PROD_HOSTS.includes(host)) return null;
  return (
    <div
      className="bg-[#F1471D] text-white px-4 py-2.5 text-sm flex items-center justify-center gap-3 shadow-sm"
      data-testid="preview-env-banner"
      role="alert"
    >
      <span className="inline-flex w-2 h-2 rounded-full bg-white animate-pulse" />
      <span className="text-center">
        <strong className="font-semibold">Preview / test environment.</strong>{" "}
        Do <strong>not</strong> log live work here — enter all gate events,
        washes, repairs and invoices on{" "}
        <a
          href="https://depot.portside.nl"
          className="underline font-semibold hover:no-underline"
          data-testid="preview-env-banner-link"
        >
          depot.portside.nl
        </a>
        .
      </span>
    </div>
  );
}
